/**
 * 데스크톱용 Footer 컴포넌트
 * 센터의 주소, 전화번호, 대표자, 사업자등록번호 등
 * 조직의 기본 정보를 표시합니다.
 */

import styled from 'styled-components';
import logoFooter from '../assets/seem_logo_w.png';
import {
  SERVICES,
  FAX_NUMBER,
  EMAIL,
  MAIN_PHONE,
} from '../constant/contactInfo';

/**
 * Footer 컴포넌트
 * @param {Object} props
 * @param {string} props.address - API에서 가져온 주소 (우편번호 포함)
 * @param {string} props.phoneNumber - API에서 가져온 전화번호
 */
function Footer({ address, phoneNumber }) {
  /**
   * 우편번호를 찾기 위한 정규 표현식
   * 형식: (우) 다섯 자리 숫자 또는 (우)다섯 자리 숫자 (공백 선택)
   * 예시: (우) 04564 또는 (우)04564
   */
  const postalCodeRegex = /\(우\)\s?\d{5}/;

  /**
   * 주소 문자열에서 우편번호 추출
   * 우편번호가 없으면 빈 문자열 반환
   */
  const postalCode =
    address && address.match(postalCodeRegex)
      ? address.match(postalCodeRegex)[0]
      : '';

  /**
   * 주소에서 우편번호 부분을 제거하여 실제 주소만 추출
   * 예시: "서울시 중구 다산로 44길 11, 4층"
   */
  const realAddress = address
    ? address.replace(postalCodeRegex, '').trim()
    : '';

  return (
    <FooterContainer>
      <FooterBox>
        <InfoWrapper>
          {/* 주소 정보 섹션 */}
          <InfoRow>
            {postalCode && <InfoSpan>{postalCode}</InfoSpan>}
            {realAddress && <InfoSpan>{realAddress}</InfoSpan>}
            <InfoSpan>대표 : 김성기</InfoSpan>
            <InfoSpan>사업자등록번호 : 220-82-10281</InfoSpan>
            <InfoSpan>법인대표번호 : {MAIN_PHONE}</InfoSpan>
          </InfoRow>

          {/* 전화번호 섹션 */}
          <InfoRow>
            {SERVICES.slice(0, -1).map((service, index) => (
              <InfoSpan key={index}>
                {service.label} : {service.phone}
              </InfoSpan>
            ))}
          </InfoRow>

          {/* 팩스, 이메일, 저작권 섹션 */}
          <InfoRow>
            <InfoSpan>팩스 : {FAX_NUMBER}</InfoSpan>
            <InfoSpan>이메일 : {EMAIL}</InfoSpan>
            <InfoSpan>
              Copyright@2004 에스이임파워사회적협동조합 All right Reserved.
            </InfoSpan>
          </InfoRow>
        </InfoWrapper>
      </FooterBox>
    </FooterContainer>
  );
}

export default Footer;

/* Styled Components */

const FooterContainer = styled.div`
  /* 데스크톱 기본 스타일 */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fcfcfc;
  padding: 25px 0;
  border-top: 1px solid #d5d5d5;
  font-family: 'koPubWorld DotumM';
  color: #333333;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    display: block;
    padding: 0;
    border-top: none;
    width: 100%;
    background: #fcfcfc url(${logoFooter}) 10% 10% no-repeat;
    background-size: 180px;
    height: 300px;

    @media (min-width: 430px) {
      background-size: 300px;
      background-position: 9% 10%;
      height: 400px;
    }
  }
`;

const FooterBox = styled.div`
  /* 데스크톱 기본 스타일 */
  display: flex;
  align-items: center;
  background: url(${logoFooter}) left center no-repeat;
  background-size: 290px;
  padding-left: 350px;
  min-height: 109px;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    background: none;
    padding-left: 0;
    min-height: 0;
    display: block;
  }
`;

const InfoWrapper = styled.div`
  /* 데스크톱 기본 스타일 */
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    gap: 0;

    padding-top: 22%;

    @media (max-width: 320px) {
      padding-top: 20%;
    }

    @media (min-width: 768px) {
      padding-top: 13%;
    }
  }
`;

const InfoRow = styled.div`
  /* 데스크톱 기본 스타일 */
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0px 25px;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    display: block;
    gap: 0;
  }
`;

const InfoSpan = styled.span`
  /* 데스크톱 기본 스타일 */
  font-family: 'koPubWorld DotumM';
  font-size: 14px;
  color: #333333;
  white-space: nowrap;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    display: block;
    margin-left: 5%;
    margin-bottom: 1%;
    white-space: normal;
    font-size: 13px;

    @media (min-width: 768px) {
      font-size: 15px;
    }
  }
`;
